import { checkMinViewport } from "../utils/utils";

export default class ArticleSeries {
  constructor(elem, APP) {
    this.elem = elem;
    this.progressEnabled = this.elem.dataset.progress == "1" ? true : false;

    this.container = document.querySelector(".js-hero-container");
    this.hero = document.querySelector(".article-series-hero");
    this.aside = this.elem.querySelector(".js-article-aside");
    this.asideColumn = this.elem.querySelector(".js-aside-col");

    this.logo = document.querySelector(".js-hero-logo");
    this.logoTop = document.querySelector(".js-as-hero-logo-top");
    this.logoBody = document.querySelector(".js-as-hero-logo-body");

    if (this.progressEnabled) {
      this.progressBar = this.elem.querySelector(".js-article-progress-bar");
      this.tickMarks = this.progressBar.querySelectorAll("span");
    }

    this.darkBgElems = this.elem.querySelectorAll(".article-video");
    this.observed = false;

    this.windowWidth = window.innerWidth;
    this.enabled = checkMinViewport(1200); // enable scroll func based on the vp
  }

  resizeWindow() {
    if (this.windowWidth != window.innerWidth && this.aside) {
      if (this.aside.classList.contains("sticked")) {
        this.aside.style.width = `${this.asideColumn.offsetWidth}px`;
        this.aside.style.left = `${
          this.container.offsetLeft + this.asideColumn.offsetLeft
        }px`;
      } else {
        this.aside.style.width = `100%`;
        this.aside.style.left = 0;
      }

      this.windowWidth = window.innerWidth;
    }

    this.enabled = checkMinViewport(1200);
  }

  updateProgressBar(winSY) {
    // const targetHeight = (this.elem.offsetHeight + this.elem.offsetTop) / 10;
    const targetHeight = (this.elem.offsetHeight - 300) / 10;

    if (winSY - this.elem.offsetTop > 0) {
      const count = Math.ceil((winSY - this.elem.offsetTop) / targetHeight);

      this.tickMarks.forEach((mark, id) => {
        mark.classList[id < count ? "add" : "remove"]("enabled");
      });
    } else {
      this.tickMarks.forEach((mark, id) => {
        mark.classList.remove("enabled");
      });
    }
  }

  onScroll() {
    if (!this.enabled) return;

    const winSY = window.scrollY;
    const logoGap = winSY - this.container.offsetTop + 90;
    const progressGap = winSY - this.hero.offsetHeight + 90;

    if (logoGap > 0) {
      this.logo.classList.add("sticked");
      this.logo.style.width = `${this.asideColumn.offsetWidth}px`;
      this.logo.style.left = `${
        this.container.offsetLeft + this.asideColumn.offsetLeft
      }px`;
    } else {
      this.logo.classList.remove("sticked");
      this.logo.style.width = `100%`;
      this.logo.style.left = 0;
    }

    // stickiness
    if (progressGap > 0) {
      if (this.aside) {
        this.aside.classList.add("sticked");
        this.aside.style.width = `${this.asideColumn.offsetWidth}px`;
        this.aside.style.left = `${
          this.container.offsetLeft + this.asideColumn.offsetLeft
        }px`;
      }

      if (!this.observed) {
        this.logo.classList.add("body");
      }
    } else {
      if (this.aside) {
        this.aside.classList.remove("sticked");
        this.aside.style.width = `100%`;
        this.aside.style.left = 0;
      }

      if (!this.observed) {
        this.logo.classList.remove("body");
      }
    }

    // hide aside
    if (winSY > this.elem.offsetHeight + this.hero.offsetHeight - 360) {
      if (this.aside) this.aside.style.top = "-1000px";
      this.logo.style.top = "-1000px";
    } else {
      if (this.aside)
        this.aside.style.top = this.aside.classList.contains("sticked")
          ? "190px"
          : "auto";
      this.logo.style.top = this.logo.classList.contains("sticked")
        ? "90px"
        : "auto";
    }

    // progress bar
    if (this.progressEnabled) {
      this.updateProgressBar(winSY);
    }
  }

  setupSubnav() {
    this.blocks.forEach((block, id) => {
      block.id = `section-${id}`;
      const btn = document.createElement("button");
      const txt = document.createTextNode(block.innerText);
      btn.id = `section-${id}`;
      btn.appendChild(txt);

      this.subnav.appendChild(btn);
      this.subnavButtons.push(btn);

      btn.addEventListener("click", () => {
        const targetY =
          this.articleContent.querySelector(`#section-${id}`).offsetTop +
          this.container.offsetTop -
          90;
        window.scroll({
          top: targetY,
          left: 0,
          behavior: "smooth",
        });
      });
    });
  }

  init() {
    window.addEventListener("scroll", () => {
      this.onScroll();
    });

    window.addEventListener("resize", () => {
      this.resizeWindow();
    });

    let observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.observed = entry.isIntersecting;

          if (window.scrollY > this.hero.clientHeight) {
            if (entry.isIntersecting) {
              this.logo.classList.remove("body");
            } else {
              this.logo.classList.add("body");
            }
          }
        });
      },
      {
        rootMargin: "0px 0px -95% 0px",
        threshold: 0,
      }
    );

    this.darkBgElems.forEach((elem) => {
      observer.observe(elem);
    })
  }
}
